
// 商品管理权限
const COMMODITY = {
	COMMODITY_ADD: 9999990001001, // 添加商品/分类/属性
	COMMODITY_EDIT: 9999990001002, // 编辑商品/分类/属性
	COMMODITY_DELETE: 9999990001003, // 删除商品/分类/属性
	COMMODITY_PUBLISH: 9999990001004, // 上架商品
	COMMODITY_VIEW: 9999990001005, // 查看商品/分类/属性
};

// 订单管理权限
const ORDER = {
	REFUND_ORDER: 9999990002001,  // 商家主动退款（商品退款）
	PICK_UP: 9999990002002, // 发货/备货
	ORDER_PRINT_RECEIPT: 9999990002003, // 打印小票
	ORDER_CANCEL_DELIVER: 9999990002004, // 取消发货
	ORDER_WRITE_OFF: 9999990002005, // 核销
	ORDER_VIEW: 9999990002006, // 交易记录查看
	HANDLE_WITH_REFUND_APPLICATION: 9999990003001, // 同意/驳回退款申请
	REFUND_VIEW: 9999990003002, // 退款记录查看
};

// 评论管理权限
const COMMENT = {
	EVALUATE_REPLY: 9999990004001, //  评论回复
	EVALUATE_VIEW: 9999990004002, //  评论查看
};

// 交易概览权限
const TRADE = {
	TRADE_OVERVIEW: 9999990005001, //  交易概览
};

// 设备管理权限
const DEVICE = {
	DEVICE_ADD: 9999990006001,  //  新增打印机
	DEVICE_EDIT: 9999990006002, //  编辑打印机
	DEVICE_DELETE: 9999990006003,  //  删除打印机
	RECEIPT_STYLE: 9999990006004,  //  小票样式
	DEVICE_VIEW: 9999990006005,  //  打印机查看
	CASHIER_BIND: 9999990006006, // 绑定收银机
	CASHIER_UNBIND: 9999990006007, // 解绑收银机
	CASHIER_EDIT: 9999990006008, // 编辑收银机名称
	CASHIER_VIEW: 9999990006009, // 收银机查看
};

// 员工管理权限
const STAFF = {
	STORE_USER_MANAGEMENT: 9999990007001,  //  店员管理
};

// 门店设置权限
const STORE = {
	STORE_SETTING: 9999990008001,  //  编辑（店铺设置）
	COLLECTION_CODE_DOWNLOAD: 9999990008002,  //  收款码下载
	STORE_VIEW: 9999990008003,  //  店铺查看
	STATION_ADD: 9999990009001,  //  站点新增
	STATION_EDIT: 9999990009002,  //  站点修改
	STATION_DELETE: 9999990009003, //  站点删除
	STATION_VIEW: 9999990009004, //  站点查看
	BOOKING_MANAGEMENT: 9999990010001, //  预定管理
	STALL_ADD: 9999990011001, //  档口新增
	STALL_EDIT: 9999990011002, //  档口修改
	STALL_DELETE: 9999990011003, //  档口删除
	STALL_VIEW: 9999990011004, //  档口查看
	TABLE_NO: 9999990012001, //  桌号管理
	SCAN_WRITE_OFF: 9999990013001, //  扫码验单
};

// 营销权限
const BUSINESS = {
	BUSINESS_COUPON_ADD: 284700002001, //  业务营销新增卡券
	BUSINESS_COUPON_EDIT: 284700002002, //  业务营销编辑卡券
	BUSINESS_COUPON_DELETE: 284700002003, //  业务营销删除卡券
	BUSINESS_COUPON_ISSUE_ADD: 284700002004, //  业务营销新增卡券发放
	BUSINESS_COUPON_ISSUE_OPEN_AND_CLOSE: 284700002005, //  业务营销开启/关闭卡券发放
	BUSINESS_COUPON_RECEIVE_ADD: 284700002006, //  业务营销新增卡券领取
	BUSINESS_COUPON_RECEIVE_EDIT: 284700002007, //  业务营销编辑卡券领取
	BUSINESS_COUPON_RECEIVE_DELETE: 284700002008, //  业务营销删除卡券领取
	BUSINESS_COUPON_EXPORT: 284700002009, //  业务营销卡券导出
	BUSINESS_COUPON_OVERVIEW: 284700002010, //  业务营销卡券促销查看
	BUSINESS_ACTIVITY_ADD: 284700003001, //  业务营销新增活动
	BUSINESS_ACTIVITY_OPEN_AND_CLOSE: 284700003002, //  业务营销开启/关闭活动
	BUSINESS_ACTIVITY_EDIT: 284700003003, //  业务营销编辑活动
	BUSINESS_ACTIVITY_DELETE: 284700003004, //  业务营销删除活动
	BUSINESS_ACTIVITY_OVERVIEW: 284700003005, //  业务营销活动促销查看
};

// 账户权限
const ACCOUNT = {
	ACCOUNT_TOP_UP: 283000001001, //  账户充值
	ACCOUNT_WITHDRAW: 283000001002, //  账户提现
	ACCOUNT_EDIT: 283000001003, //  编辑账户信息
	ACCOUNT_WITHDRAW_PHONE_UPDATE: 283000001004, //  修改提现手机号
	ACCOUNT_AUTO_WITHDRAW_SETTING: 283000001005, //  自动提现设置
	ACCOUNT_HOMEPAGE_OVERVIEW: 283000001006, //  商户主页查看

	FINANCE_DETAIL_EXPORT: 283000002001, //  账务明细导出
	FINANCE_DETAIL_OVERVIEW: 283000002002, //  账户明显查看

	TRADE_DETAIL_EXPORT: 283000003001, //  交易明细导出
	TRADE_DETAIL_OVERVIEW: 283000003002, //  交易明细查看
};

// 结算权限
const SETTLE = {
	MALL_SETTLE_MERCHANT_BILL_VIEW: 284700005001, // 【商城】 结算方查看结算单
	MALL_SETTLE_MERCHANT_BILL_EXPORT: 284700005002, // 【商城】 结算方导出结算单
	MALL_SETTLE_MERCHANT_BILL_SETTLEMENT: 284700005003, // 【商城】 结算方结算
	STORE_SETTLED_MERCHANT_BILL_VIEW: 284700005004, // 【店铺】 被结算方查看结算单
	STORE_SETTLED_MERCHANT_BILL_EXPORT: 284700005005, // 【店铺】 被结算方导出结算单
};

// 商城权限
const MALL = {
	MALL_TRADE_OVERVIEW: 99999900014001, // 【商城】交易概览查看

	MALL_OPEN_STORE: 99999900015001,  //  【商城】 开启店铺
	MALL_DELETE_STORE: 99999900015002, //  【商城】 删除店铺
	MALL_CLOSE_STORE: 99999900015003, //  【商城】 关闭店铺
	MALL_AUDIT_STORE: 99999900015004, //  【商城】 审核店铺
	MALL_CHANGE_STORE_ADMINISTRATOR: 99999900015005, // 【商城】 更换负责人
	MALL_STORE_VIEW: 99999900015006, // 【商城】 店铺查看

	MALL_ORDER_VIEW: 99999900016001, // 【商城】 交易记录查看

	MALL_USER_MANAGEMENT: 99999900017001, // 【商城】 员工管理

	MALL_SETTING: 99999900018001, // 【商城】 商城编辑
	MALL_COLLECTION_CODE_DOWNLOAD: 99999900018002, // 【商城】 收款码下载
	MALL_VIEW: 99999900018003, // 【商城】 商城查看
};

export default {
	COMMODITY,
	ORDER,
	COMMENT,
	STAFF,
	STORE,
	TRADE,
	DEVICE,
	ACCOUNT,
	BUSINESS,
	MALL,
	SETTLE
};
